import { render, staticRenderFns } from "./OtherAttributesList.vue?vue&type=template&id=4251305b&scoped=true&"
import script from "./OtherAttributesList.vue?vue&type=script&lang=js&"
export * from "./OtherAttributesList.vue?vue&type=script&lang=js&"
import style0 from "./OtherAttributesList.vue?vue&type=style&index=0&id=4251305b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4251305b",
  null
  
)

export default component.exports